// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"119":"02cf0949","237":"a726b9a1","493":"0663a45e"}[chunkId] + ".chunk.css";
};